import {
  LOAD_INITIAL_DATA_REQUEST, LOAD_INITIAL_DATA_ERROR, LOAD_INITIAL_DATA_SUCCESS, SET_LANGUAGE,
} from './types';
import { USER_REQUEST, FETCH_USER_CONTACTS_REQUEST } from '../user/types';
import { FETCH_CURRENCIES_REQUEST } from '../currency/types';
import { SET_EVENT_CURRENCY } from '../events/types';

const loadInitialData = async ({ commit, dispatch, rootState }) => {
  commit(LOAD_INITIAL_DATA_REQUEST);
  try {
    await Promise.all([
      dispatch(USER_REQUEST),
      dispatch(FETCH_USER_CONTACTS_REQUEST),
      dispatch(FETCH_CURRENCIES_REQUEST),
    ]);
    commit(SET_EVENT_CURRENCY, rootState.user.user.currency);
    commit(LOAD_INITIAL_DATA_SUCCESS);
    return Promise.resolve(rootState.user.user);
  } catch (e) {
    commit(LOAD_INITIAL_DATA_ERROR);
    // throw new Error('unable to load initial data');
    return Promise.reject(e);
  }
};

const setLocale = ({ commit }, language) => {
  commit(SET_LANGUAGE, language);
  localStorage.setItem('locale', language);
};

export const actions = {
  [LOAD_INITIAL_DATA_REQUEST]: loadInitialData,
  [SET_LANGUAGE]: setLocale,
};
